import { formatCPF } from '../../Funcoes/FormatCPF';
import styles from './AdmissaoFilter.module.css';

import { useEffect, useMemo, useState } from 'react';
import Filters from '../Utils/Filters';
import FilterContainer from '../Utils/FilterContainer';
import MultiselectCheck from '../Utils/MultiselectCheck';
import GenericHeader from '../GenericHeader';

const AdmissaoFilter = ({ tabelaValues, filterTable, tabelaForFilters }) => {

    const safeTabelaValues = Array.isArray(tabelaValues) ? tabelaValues : [];
    const safeTabelaForFilters = Array.isArray(tabelaForFilters) ? tabelaForFilters : [];

    const opcoesFuncao = useMemo(
        () => Array.from(
            new Set(safeTabelaForFilters.map((obj) => obj.funcao).filter(Boolean))
        ).sort().map((funcao) => ({ value: funcao, label: funcao })),
        [safeTabelaForFilters]
    );

    const opcoesOrigem = useMemo(
        () => Array.from(
            new Set(safeTabelaForFilters.map((obj) => obj.cc_origem).filter(Boolean))
        ).sort().map((obra) => ({ value: obra, label: obra })),
        [safeTabelaForFilters]
    );

    const opcoesDestino = useMemo(
        () => Array.from(
            new Set(safeTabelaForFilters.map((obj) => obj.cc_destino).filter(Boolean))
        ).sort().map((obra) => ({ value: obra, label: obra })),
        [safeTabelaForFilters]
    );

    const opcoesMotivo = useMemo(() => [
        { value: 'ADMISSAO', label: 'ADMISSAO' },
        { value: 'TRANSFERENCIA', label: 'TRANSFERENCIA' },
    ], []);

    const opcoesDesistente = useMemo(() => [
        { value: 'SIM', label: 'SIM' },
        { value: 'NAO', label: 'NÃO' },
    ], []);

    const opcoesStatus = useMemo(() => [
        { value: 'EM ANDAMENTO', label: 'EM ANDAMENTO' },
        { value: 'FINALIZADO', label: 'FINALIZADO' },
    ], []);

    const [nomeFilter, setNomeFilter] = useState('');
    const [cpfFilter, setCpfFilter] = useState('');
    const [funcaoFilter, setFuncaoFilter] = useState([]);
    const [ccOrigem, setCcOrigem] = useState([]);
    const [ccDestino, setCcDestino] = useState([]);
    const [motivoFilter, setMotivoFilter] = useState([]);
    const [desistFilter, setDesistFilter] = useState([]);
    const [statusFilter, setStatusFilter] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {

        filterTable(
            nomeFilter,
            cpfFilter,
            funcaoFilter,
            ccOrigem,
            ccDestino,
            motivoFilter,
            desistFilter,
            statusFilter,
            startDate,
            endDate
        );

    }, [
        nomeFilter,
        cpfFilter,
        funcaoFilter,
        ccOrigem,
        ccDestino,
        motivoFilter,
        desistFilter,
        statusFilter,
        startDate,
        endDate,
        filterTable,
    ]);

    const totalFinalizados = safeTabelaValues.filter(
        (obj) => obj.status === 'ENTROU NO SITE' || obj.desistente === '*'
    ).length;
    const totalAndamento = safeTabelaValues.filter(
        (obj) => obj.status !== 'ENTROU NO SITE' && obj.desistente === null
    ).length;

    return (
        <GenericHeader responsive>
            <Filters columns={5}>
                <FilterContainer
                    type="text"
                    placeholder="COLABORADOR..."
                    valor={nomeFilter}
                    changeFunc={setNomeFilter}
                />
                <FilterContainer
                    type="text"
                    placeholder="CPF..."
                    valor={cpfFilter}
                    changeFunc={(value) => {
                        const digits = String(value).replace(/\D/g, '');
                        setCpfFilter(formatCPF(digits));
                    }}
                />
                <MultiselectCheck
                    options={opcoesFuncao}
                    selectedOptions={funcaoFilter}
                    setSelectedOptions={setFuncaoFilter}
                    placeholder="FUNÇÃO..."
                />
                <MultiselectCheck
                    options={opcoesOrigem}
                    selectedOptions={ccOrigem}
                    setSelectedOptions={setCcOrigem}
                    placeholder="CC ORIGEM..."
                />
                <MultiselectCheck
                    options={opcoesDestino}
                    selectedOptions={ccDestino}
                    setSelectedOptions={setCcDestino}
                    placeholder="CC DESTINO..."
                />
                <MultiselectCheck
                    options={opcoesMotivo}
                    selectedOptions={motivoFilter}
                    setSelectedOptions={setMotivoFilter}
                    placeholder="MOTIVO..."
                />
                <MultiselectCheck
                    options={opcoesDesistente}
                    selectedOptions={desistFilter}
                    setSelectedOptions={setDesistFilter}
                    placeholder="DESISTENTES..."
                />
                <MultiselectCheck
                    options={opcoesStatus}
                    selectedOptions={statusFilter}
                    setSelectedOptions={setStatusFilter}
                    placeholder="STATUS..."
                />
                <FilterContainer
                    type="date"
                    valor={startDate}
                    changeFunc={setStartDate}
                />
                <FilterContainer
                    type="date"
                    valor={endDate}
                    changeFunc={setEndDate}
                />
            </Filters>

            <div className={styles.statsContainer}>
                <div className={styles.statsBox}>
                    <p>TOTAL: {safeTabelaValues.length}</p>
                    <p>FINALIZADOS: {totalFinalizados}</p>
                    <p>EM ANDAMENTO: {totalAndamento}</p>
                </div>
            </div>
        </GenericHeader>
    );

};

export default AdmissaoFilter;
